import React, { useEffect, useState } from "react";
// import logo from "../../AdminDashboard/image/shambasync-5mk.webp";
import logo from "../../AdminDashboard/assets/dextra-logo.jpeg";
import { getWithTokenAPI, postWithoutTokenAPI } from "../../utils/Api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/auth/action";

// Material-UI Imports
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import {
  MailOutline,
  Lock,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { getpermission } from "../../store/rolleSlice";

// Accept onAdminNameChange and setIsLoggedIn as props
function AdminLogin({ onAdminNameChange, setIsLoggedIn }) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [role, setrole] = useState(null)
  
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showToast = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!email || !password) {
      showToast("Please enter both email and password.", "error");
      setLoading(false);
      return;
    }


    try {
      const response = await postWithoutTokenAPI("/user/login", {
        email,
        password,
        role: "admin",
      });

      if (response.statusCode === 200 && response.data?.access_token) {
        const token = response.data.access_token;

        // Extract 'name' from response.data (assuming your backend sends it)
        const adminId = response.data._id;
        const adminEmail = response.data.email;
        // Safely get adminName, provide a fallback if 'name' isn't directly available
        const adminName = response.data.name || response.data.username || response.data.email.split('@')[0];
        const adminrole_id = response.data.role_id

        // Construct the object to store in localStorage
        const userInfoToStore = {
          email: adminEmail,
          _id: adminId,
          name: adminName, // Store the extracted name
          role_id: adminrole_id
        };

        localStorage.setItem("token", token);
        localStorage.setItem("adminInfo", JSON.stringify(userInfoToStore));
        localStorage.setItem("isLoggedIn", "true");

        if (!!adminrole_id) {
          const token = localStorage.getItem("token");
          try {
            const res = await getWithTokenAPI(token, `/rolemanagement/find-particular?_id=${adminrole_id}`);
            if (res.data && res.data.permissions) {
              localStorage.setItem("permissions", JSON.stringify(res.data.permissions));
            }
          } catch (error) {
            console.error("Error fetching role:", error);
          }
        }

        // Dispatch Redux action
        dispatch(loginSuccess(userInfoToStore, token));


        // --- Call the prop functions to update App.js state ---
        if (onAdminNameChange) {
          onAdminNameChange(adminName, adminId); // Pass adminName and adminId to update App.js
        }
        if (setIsLoggedIn) {
          setIsLoggedIn(true); // Inform App.js that the user is now logged in
        }
        // --- End of prop function calls ---

        showToast("Login successful!", "success");
        setTimeout(() => {
          navigate("/backoffice/"); // Redirect to the dashboard
        }, 1000);
      } else {
        showToast(
          response.message || "Login failed. Invalid credentials.",
          "error"
        );
      }
    } catch (err) {
      console.error("AdminLogin: NETWORK/SERVER ERROR in catch block:", err);
      showToast(
        "Network error or server unavailable. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
      console.log("AdminLogin: ENDING LOGIN PROCESS.");
    }
  };

  return (
    <Container
      maxWidth="false"
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 500,
          width: "100%",
          p: 4,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 3,
          border: "1px solid #e9ecef",
          height: "550px"
        }}

      >
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img
            src={logo}
            alt="company_logo"
            style={{ width: "100%", maxWidth: 400, height: "auto" }}
          />
        </Box>
        <Typography
          variant="h5"
          component="h1"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#DC3545", mb: 4 }}
        >
          Welcome back chief!
        </Typography>

        {/* Login Form */}
        <Box component="form" onSubmit={handleLogin} sx={{ px: 1 }}>
          {/* Email Field */}
          <TextField
            fullWidth
            label="Enter your email"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutline sx={{ color: "#DC3545" }} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            label="Enter your password"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock sx={{ color: "#DC3545" }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={togglePasswordVisibility}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              py: 1.5,
              fontWeight: "bold",
              fontSize: "1rem",
              bgcolor: "#DC3545",
              "&:hover": {
                bgcolor: "#009606",
              },
              borderRadius: "8px",
              marginTop: '15px'
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
          </Button>
        </Box>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default AdminLogin;